import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';
import ReactMarkdown from 'react-markdown';
import WelcomeMarkdown from 'app/content/welcome.md';
import WelcomeGameDayMarkdown from 'app/content/welcome-gameday.md';

interface IWelcomeProps {
  appReady: boolean;
  match: any;
}
export default class Welcome extends React.Component<IWelcomeProps> {
  static defaultProps: IWelcomeProps = {
    appReady: false,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="welcome-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Welcome to Teammo!"
            />
          </div>
        </div>
        <div className="row">
          <div className="col welcome-content">
            {this.props.match.params.provider === 'gameday' && <ReactMarkdown>{WelcomeGameDayMarkdown}</ReactMarkdown>}
            {this.props.match.params.provider !== 'gameday' && <ReactMarkdown>{WelcomeMarkdown}</ReactMarkdown>}
          </div>
        </div>
      </RenderContent>
    );
  }
}
